import React from 'react'
import PropTypes from 'prop-types'

import { ArrowBackComponent } from './styles'

import 'material-icons/iconfont/filled.css'

const ArrowBack = ({ style, onClick }) => (
  <ArrowBackComponent
    style={style}
    onClick={onClick}
    className="material-icons"
  >
    arrow_back
  </ArrowBackComponent>
)

ArrowBack.propTypes = {
  style: PropTypes.shape({}),
  onClick: PropTypes.func,
}

ArrowBack.defaultProps = {
  style: null,
  onClick: null,
}

export default ArrowBack
